/**
 * MypageWishlistContainer
 * --
 */
import React from 'react';
import MypageWishlistPresenter from './MypageWishlistPresenter';
import { useDefaultShopDataStack, useUserDataStack } from 'store';
import { extractApplicationPolicy, STORE_URL } from 'utils';

const MypageWishlistContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== Store ===== */
  const { wishlist } = useUserDataStack();
  const { products, policies, promotion } = useDefaultShopDataStack();

  /* ===== Mutate ===== */
  /* ===== PROPS ===== */
  const { screenSize } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 위시리스트
   * --
   */
  const WishList = React.useMemo(() => {
    const newWish = wishlist
      .filter((wish) => wish.product_id && wish.type === 'WISH')
      .map((wish) => {
        // 위시리스트 상품 찾기
        const findProduct = products?.find(
          (product) => wish.product_id === product.product_id
        );

        if (!findProduct) return null;

        const { product_file, price, product_id, product_name } = findProduct;

        // 썸네일 추출
        const thumbnail =
          product_file?.find((file) => file.type === 'THUMBNAIL') || null;

        // 적용 정책 추출
        const applyPolicy = policies?.filter((policy) =>
          policy.map_product_policy.some((map) => map.product_id === product_id)
        );
        // 우선순위에 따른 적용되는 정책 추출
        const applicationPolicy = applyPolicy?.length
          ? extractApplicationPolicy(applyPolicy, price, promotion)
          : null;

        return {
          key: wish.wishlist_id,
          productKey: wish.product_id,
          src: thumbnail ? `${STORE_URL}/${thumbnail.file_url}` : null,
          title: product_name,
          price: price,
          discount: applicationPolicy ? applicationPolicy.discount_rate : null,
          type: applicationPolicy ? applicationPolicy.discount_type : null,
        };
      });

    return newWish;
  }, [wishlist, products, policies, promotion]);

  /* ===== RENDER ===== */
  return (
    <>
      <MypageWishlistPresenter
        wishlist={WishList}
        props={props}
        screenSize={screenSize}
      />
    </>
  );
};

export default MypageWishlistContainer;
